import React, {useEffect, useLayoutEffect, useRef, useState} from 'react'
import {FormattedMessage} from 'react-intl'
import {Link} from 'react-router-dom'
import {ICar} from '../../../../models/Car'
import {IPost} from '../../../../models/Post'
import {IStation} from '../../../../models/Station'
import ResponsiveImg,{ getResponsiveSrcSetsFromWH } from '../../common/ResponsiveImg'
import {carTypes, Locale, urlPrefixes} from '../../../config/constants'
import {getCurrentCarsUrl, getMapCarsUrl,getCarTypesUrl, getCarModelUrl, getKeywordUrl } from '../../../helpers/car'
import {getGlobalEnv, isBrowser} from '../../../helpers/coreUtil'
import {getCurrentStationsUrl, getMapStationsUrl} from '../../../helpers/station'
import LocaleText from '../../common/LocaleText'
import {IRouteComponentProps} from '../../containers/DataResolver'
import {useIsSsr, useLocale, useLocationPermission, useSEO, useSm} from '../../hocs/hooks'
import {CarListItems,CarTypeListItems, PostListItems, ReviewListItems, StationListItems} from '../TopListItems'
import AngleLeft from '../../../assets/icons/AngleLeft.svg'
import AngleRight from '../../../assets/icons/AngleRight.svg'
import CoverPC from './CoverPC'
import CoverSm from './CoverSM'
import {IHomeReview} from './ReviewItem'
import HomeStatement from './HomeStatement'
import styles from './VanShareHome.scss'
import Pickup from './Pickup'
import { loadHubspotChat } from '../../../helpers/util'
import RegisterGuest from './RegisterGuest'
import BannerRecruitmentPC from '../../../assets/imgs/new-vanshare/banner_recruitment_pc.jpg'
import BannerRecruitmentPCDimention from '../../../assets/imgs/new-vanshare/banner_recruitment_pc.jpg?size'
import BannerRecruitmentSP from '../../../assets/imgs/new-vanshare/banner_recruitment_sp.jpg'
import lightCamperVan from '../../../assets/imgs/new-vanshare/carType/lightCamperVan.png'
import vancon from '../../../assets/imgs/new-vanshare/carType/vancon.png'
import cabcon from '../../../assets/imgs/new-vanshare/carType/cabcon.png'
import motorhome from '../../../assets/imgs/new-vanshare/carType/motorhome.png'
import roofTopTent from '../../../assets/imgs/new-vanshare/carType/roofTopTent.png'
import trailer from '../../../assets/imgs/new-vanshare/carType/trailer.png'
import BannerMobilabPC from '../../../assets/imgs/new-vanshare/banner_mobilab_pc.png'
import BannerMobilabSP from '../../../assets/imgs/new-vanshare/banner_mobilab_sp.png'
import { useSelector } from 'react-redux'
import { IState } from '../../../config/store'
import DownloadApp from './DownloadApp'
import { isNativeWebview } from '../../../helpers/reactNativeWebview'
import AreaPrefectureList from '../AreaPrefectureList'
import BannerMobilab from './BannerMobilab'

const VanShareHome = ({resolvedData: {featuredCars, topCars, topPosts, topReviews, stations, carMakers}}: IRouteComponentProps<{
  featuredCars: ReadonlyArray<ICar>
  topCars: ReadonlyArray<ICar>
  topPosts: ReadonlyArray<IPost>
  newCars: ReadonlyArray<ICar>
  topReviews: ReadonlyArray<IHomeReview>
  stations: ReadonlyArray<IStation>
  carMakers: Array<any>
}>) => {
  const locale = useLocale()
  const ref = useRef<HTMLDivElement>(null)
  const isSm = useSm()
  const isMobileApp = !useIsSsr() && isNativeWebview()

  const isLocationPermission = useLocationPermission()

  const popularCarsRef = useRef<HTMLDivElement>(null)
  loadHubspotChat(getGlobalEnv('HUBSPOT_ID'))

  const cdn = getGlobalEnv('CDN_BASE_URL')
  const srcMobilePC = getResponsiveSrcSetsFromWH(BannerRecruitmentPC, 1100, undefined, { webp: false, cdn })
  const srcMobileSP = getResponsiveSrcSetsFromWH(BannerRecruitmentSP, 335, undefined, { webp: false, cdn })
 
  const srcMobilabPC = getResponsiveSrcSetsFromWH(BannerMobilabPC, 1100, undefined, { webp: false, cdn })
  const srcMobilabSP = getResponsiveSrcSetsFromWH(BannerMobilabSP, 335, undefined, { webp: false, cdn })

  const [leftAngleState, setLeftAngleState] = useState(true)
  const [rightAngleState, setRightAngleState] = useState(false)

  useSEO({
    canonicalUrl: `${getGlobalEnv('BASE_URL')}/${locale}/`
  })
  const {
    loggedIn,
  } = useSelector(
    ({
      session: {
        loggedIn,
        user,
      },
    }: IState) => ({
      loggedIn,
      user,
    })
  )

  const carTypesList = carTypes
  return <div>
    <div className={'w-100'} ref={ref}>
      {isSm ? <CoverSm/> : <CoverPC/>}
    </div>
    <div className={styles.topMargin}/>
    {/* はじめて */}
    <div className={styles.mainPadding}>
      {locale === Locale.ja && <h2
        className={[styles.title, 'font-weight-bold'].join(' ')}>
        はじめての方へ
      </h2>}
      <Pickup />
    </div>
    <div className="mb-md-5 mb-4"/>

    {/* 注目 */}
    <div ref={popularCarsRef} className={styles.mainPadding}>
      <section className={['d-flex justify-content-between', styles.section].join(' ')}>
        <h2 className={[styles.title, 'font-weight-bold'].join(' ')}>
          <LocaleText ja="注目のキャンピングカー" en="Featured camper van"/>
        </h2>
        {false && <div className={styles.seeAll}>
          <Link to={`/${locale}${urlPrefixes.user}/cars/featured/`} title="すべてのキャンピングカーを見る/リスト">
            <FormattedMessage id="post.seeAll" />
          </Link>
        </div>}
      </section>
      <div className={styles.mainSmPadding}>
        <CarListItems cars={featuredCars} multiTitle isCatchphrase/>
      </div>
    </div>
    <div className="mb-md-4 mb-4 pb-md-3"/>

    {/* エリア・都道府県から探す */}
    <div className={styles.mainPadding}>
      <section className={['d-flex justify-content-between', styles.section].join(' ')}>
        <h2 className={[styles.title, 'font-weight-bold'].join(' ')}>
          <LocaleText ja="エリア・都道府県から探す" en="Search by area"/>
        </h2>
      </section>
      <div className={styles.areaSmPadding}>
        <AreaPrefectureList />
      </div>
    </div>
    <div className="mb-md-4 mb-4 pb-md-3"/>

    {/* 会員登録 */}
    {loggedIn
      ? !isMobileApp && <><DownloadApp /><div className="mb-5 pb-md-3"/></>
      : <><RegisterGuest /><div className="mb-5 pb-md-3"/></>
    }

    {/* 人気のキャンピングカー */}
    <div ref={popularCarsRef} className={[styles.mainPadding].join(' ')}>
      <section className={['d-flex justify-content-between', styles.section].join(' ')}>
        <h2 className={[styles.title, 'font-weight-bold'].join(' ')}>
          <LocaleText ja="人気のキャンピングカー" en="Popular camper van"/>
        </h2>
        <div className={['mr-3px mt-3px', styles.seeAll].join(' ')}>
          <Link to={isLocationPermission
            ? getCurrentCarsUrl(locale, false, true)
            : getMapCarsUrl(locale, false, true)}
                title="すべてのキャンピングカーを見る/リスト"
          >
            <FormattedMessage id="post.seeAll" />
          </Link>
        </div>
      </section>
      <div className={styles.mainSmPadding}>
        <CarListItems cars={topCars} />
      </div>
    </div>
    <div className="mb-md-4 mb-4 pb-md-3"/>

    {/* 人気の車中泊スポット・アクティビティ */}
    <div className={[styles.mainPadding].join(' ')}>
      <section className={['d-flex justify-content-between', styles.section].join(' ')}>
        <h2 className={[styles.title, 'font-weight-bold'].join(' ')}>
          <LocaleText ja="人気の車中泊スポット・アクティビティ" en="Popular overnight spots and activities"/>
        </h2>
        <div className={['mr-3px mt-3px', styles.seeAll].join(' ')}>
          <Link to={isLocationPermission
            ? getCurrentStationsUrl(locale, false, true)
            : getMapStationsUrl(locale, false, true)}
            title="すべてのスポットを見る/リスト"
          >
            <FormattedMessage id="post.seeAll" />
          </Link>
        </div>
      </section>
      <div className={styles.mainSmPadding}>
        <StationListItems stations={stations}/>
      </div>
    </div>
    <div className="mb-md-4 mb-4 pb-md-3"/>

    <div>
      <BannerMobilab isTop url={isSm ? BannerMobilabSP : BannerMobilabPC} srcSet={isSm ? srcMobilabSP : srcMobilabPC}/>
    </div>

    {/* 車両タイプから探す */}
    <div className={[styles.mainPadding].join(' ')}>
      <section className={['d-flex justify-content-between', styles.section].join(' ')}>
        <h2 className={[styles.title, 'font-weight-bold'].join(' ')}>
          <LocaleText ja="車両タイプから探す" en="Search by Car Type"/>
        </h2>
        <div className={styles.seeAll}>
          <Link to={getCarTypesUrl(locale,false)}
                title="すべて見る"
          >
            <FormattedMessage id="post.seeAll" />
          </Link>
        </div>
      </section>
      <div className={styles.mainSmPadding}>
        <CarTypeListItems carTypes={carTypesList}/>
      </div>
    </div>
    <div className="mb-md-4 mb-4 pb-md-3"/>

    {/* メーカー・車種から探す */}
    <div ref={popularCarsRef} className={[styles.mainPadding].join(' ')}>
      <section className={['d-flex justify-content-between', styles.section].join(' ')}>
        <h2 className={[styles.title, 'font-weight-bold'].join(' ')}>
          <LocaleText ja="メーカー・車種から探す" en="Search by manufacturer and model"/>
        </h2>
        <div className={styles.seeAll}>
          <Link to={getCarModelUrl(locale,false)}
                title="すべて見る"
          >
            <FormattedMessage id="post.seeAll" />
          </Link>
        </div>
      </section>
      {/* PC */}
      <div className={['d-md-block d-none'].join(' ')}>
        <div className={styles.border}>
          {carMakers.map((carMaker,index) => {
          return <Link
            key={carMaker._id}
            className={['mb-2 d-inline-block col-md-2', 
            (index === 0 || index % 6 === 0) ? styles.tag
          : (index === 1 || index % 6 === 1) ? styles.tag1
          : (index === 2 || index % 6 === 2) ? styles.tag2
          : (index === 3 || index % 6 === 3) ? styles.tag3
          : (index === 4 || index % 6 === 4) ? styles.tag4
          : styles.tag5].join(' ')}
            to={getKeywordUrl(locale, carMaker.name === 'トヨタ自動車' ? 'トヨタ' : carMaker.name, false, carMaker.name)}>
            {carMaker.name}
          </Link>
        })}
        </div>
      </div>
      {/* SP */}
      <div className={['d-block d-flex d-md-none row', styles.modelContainer].join(' ')}>
          {carMakers.filter(c => c.total >= 0).map((carMaker: any) => {
          return <div className={['col-6',
          carMaker._id === 0 ? styles.borderSp
          : carMaker._id === 2 ? styles.borderSp  
          : carMaker._id === 4 ? styles.borderSpBottom 
          : carMaker._id === 1 ? styles.borderSpLeft 
          : carMaker._id === 3 ? styles.borderSpLeft
          : styles.borderSpLeftBottom].join(' ')} key={carMaker._id}>
              <Link
                className="d-flex justify-content-between align-items-center font-weight-bold text-black"
                to={getKeywordUrl(locale, carMaker.name === 'トヨタ自動車' ? 'トヨタ' : carMaker.name, false, carMaker.name)}>
                {carMaker.name}
                <AngleRight
                  className={['fa font-size-75'].filter(Boolean).join(' ')}
                />
              </Link>
          </div>
        })}
        
      </div>

    </div>
    <div className="mb-md-4 mb-4 pb-md-3"/>

    {/* Carstay利用者のレビュー */}
    <div ref={popularCarsRef} className={[styles.mainPadding].join(' ')}>
      <section className={['d-flex justify-content-between', styles.section].join(' ')}>
        <h2 className={[styles.title, 'font-weight-bold'].join(' ')}>
          <LocaleText ja="Carstay利用者のレビュー" en="Reviews by Carstay users"/>
        </h2>
        <div className={['mt-n1 d-block d-md-none', styles.angleArea].join(' ')}>
          <span onClick={() => { setLeftAngleState(!leftAngleState) }}>
            <AngleLeft className={['mr-4', styles.angle].join(' ')} />
          </span>
          <span onClick={() => { setRightAngleState(!rightAngleState) }}>
            <AngleRight className={styles.angle}/>
          </span>
        </div>
      </section>
      <div className={styles.mainSmPadding}>
        <ReviewListItems
          reviews={topReviews}
          angleState={{ left: leftAngleState, right: rightAngleState}}
        />
      </div>
    </div>
    <div className="mb-md-4 mb-4 pb-md-3"/>

    {/* VANLIFE JAPAN */}
    <div ref={popularCarsRef} className={[styles.mainPadding].join(' ')}>
      <section className={['d-flex justify-content-between', styles.section].join(' ')}>
        <h2 className={[styles.title, 'font-weight-bold'].join(' ')}>
          VANLIFE JAPAN
          <span className={styles.subTitle}>
            <LocaleText ja="バンライフ・車中泊について紹介するメディア" en="Media about van life and staying in a car"/>
          </span>
        </h2>
        <div className={[styles.seeAll, 'mb-1 mb-md-0 align-self-end align-self-md-start'].join(' ')}>
          <Link to={`/${locale}/media/`} title="すべて見る">
            <FormattedMessage id="post.seeAll" />
          </Link>
        </div>
      </section>
      <div className={styles.mainSmPadding}>
        <PostListItems posts={topPosts}/>
      </div>
    </div>
    <div className="mb-md-4 mb-4 pb-md-3"/>

    {/* 採用バナー */}
    <div className={styles.banner}>
      <a href={'https://persistent-direction-0f1.notion.site/Carstay-e0be2ff9f2154163a2d08fd59a772caf'}>
        <ResponsiveImg
          url={isSm ? BannerRecruitmentSP : BannerRecruitmentPC}
          caption=""
          srcSet={isSm ? srcMobileSP : srcMobilePC}
        />
      </a>
    </div>
    <div className="mb-4 pb-3 pb-md-4"/>
    
    <div>
      <HomeStatement />
    </div>
  </div>
}
VanShareHome.displayName = 'VanShareHome'
export default VanShareHome
